import React from 'react';
import { camsAndForecastsPaths } from '../../utils/urls/camsAndForecastsPath';
import MetaTags from '../MetaTags';

const MapPageMeta = () => (
  <MetaTags
    title="Local surf reports, swell forecasts, and surf cams - Surfline"
    description="The most accurate and trusted surf reports, forecasts, and coastal weather. Surfers from around the world choose Surfline for dependable and up to date surfing forecasts and high quality surf content, live surf cams, and features."
    urlPath={`${camsAndForecastsPaths.base}-${camsAndForecastsPaths.map}`}
  />
);

export default MapPageMeta;
